export const iconFontAwesomeSciencefictionGalacticSenate = (
	<i className="fa-solid fa-galactic-senate"></i>
);
